<div class="modal-search">
  <form action="#">
    <input type="text" placeholder="Type sender name or sms text" class="form-control" [formControl]="searchFormControl" />
    <span class="icon-search"></span>
  </form>
</div>

<div class="modal-body-wrap">

  <div class="content-container">
    <div class="modal-body-content" *ngIf="favoriteRows.length > 0 && page === 1">
      <div class="body-title d-flex justify-content-between align-items-center">
        <h4 class="pr-10">Favourites</h4>
        <a class="text-primary" role="button" (click)="onClickFavoriteSelectAll()">{{isAllFavoritesSelected ? 'Unselect all' : 'Select all'}}</a>
      </div>
      <div class="table-holder">
        <table class="modal-table">
          <thead>
            <tr>
              <th class="r-sm">SENDERS</th>
              <th class="r-md">TEXT</th>
              <th class="r-sm">DESCRIPTION</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of favoriteRows">
              <tr *ngFor="let item of row.smsTemplateTextDtos;let i =index">
                <th class="r-sm">
                  <div class="chips" [ngClass]="row.selected ? 'selected': ''" *ngIf="i===0" (click)="onFavRowClick(row)">
                    <span class="icon-add select-btn cp"></span>
                    <!-- <span class="icon-favourite"></span> -->
                    <span class="text cp">{{row.name}}</span>
                  </div>
                </th>
                <td class="r-md">
                  <div class="chips" [ngClass]="item.selected ? 'selected': ''" (click)="onFavItemClick(row, item)">
                    <span class="icon-add select-btn cp"></span>
                    <span class="icon-favourite marked cp" (click)="onChangeFavorite($event, item)"></span>
                    <span class="text cp">{{ item.value }}</span>
                  </div>
                </td>
                <td class="r-sm">
                  <span class="description">{{item.description}}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-body-content" *ngIf="nonFavoriteRows.length > 0">
      <div class="body-title d-flex justify-content-between align-items-center">
        <h4 class="pr-10">All templates</h4>
        <a class="text-primary" role="button" (click)="onClickSelectAll()">{{isAllTemplateSelected ? 'Unselect all' : 'Select all'}}</a>
      </div>
      <div class="table-holder">
        <table class="modal-table">
          <!-- <thead>
                    <tr>
                        <th class="r-sm">Senders</th>
                        <th class="r-md">Text</th>
                        <th class="r-sm">Description</th>
                    </tr>
                </thead> -->
          <tbody>
            <ng-container *ngFor="let row of nonFavoriteRows">
              <tr *ngFor="let item of row.smsTemplateTextDtos;let i = index">
                <th class="r-sm">
                  <div class="chips" *ngIf="i===0" [ngClass]="row.selected ? 'selected': ''" (click)="onRowClick(row)">
                    <span class="icon-add select-btn cp"></span>
                    <!-- <span class="icon-favourite"></span> -->
                    <span class="text cp">{{row.name}}</span>
                  </div>
                </th>
                <td class="r-md">
                  <div class="chips" [ngClass]="item.selected ? 'selected': ''" (click)="onItemClick(row, item)">
                    <span class="icon-add select-btn cp"></span>
                    <span class="icon-favourite cp" [ngClass]="{'marked': item.userFavourite}" (click)="onChangeFavorite($event, item, MAX_FAVORITES)"></span>
                    <span class="text cp">{{item.value}} </span>
                  </div>
                </td>
                <td class="r-sm">
                  <span class="description">{{item.description}}</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div *ngIf="nonFavoriteRows.length" class="d-flex justify-content-between align-items-center my-10 has-pagination">
    <div class="pagination-left">
      <app-pagination *ngIf="totalCountRows > nonFavoriteRows.length" [pageSize]="size" [totalItems]="totalCountRows" [buttonsCount]="5" [currentPage]="page"
        (change)="onChangePage($event)"></app-pagination>
    </div>
    <div class="d-flex align-items-center justify-content-end pagination-right">
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let s of sizes" [ngClass]="{'active': s === size}" type="button">
          <a (click)="onChangeSize(s)">{{ s }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
